<footer class="main-footer">
  <div class="container-dynamic d-flex" *ngIf="!layoutConf.isMobile">
    <!-- <a
      mat-raised-button
      color="accent"
      routerLink="/others/precos"
      >Assine agora</a
    > -->
    <span class="m-auto"></span>
     <a href="https://infokaw.com.br/jkawflex"> Infokaw Software - Soluções em Software </a>
  </div>
</footer>
